import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";

export interface BrutalButtonGroupItem {
  label: string;
  to: string;
  icon?: LucideIcon;
}

interface BrutalButtonGroupProps {
  items: BrutalButtonGroupItem[];
  className?: string;
}

export const BrutalButtonGroup = ({ items, className }: BrutalButtonGroupProps) => {
  return (
    <div 
      className={cn(
        "inline-flex flex-col sm:flex-row border-[3px] border-dark shadow-[6px_6px_0px_0px] shadow-dark",
        className
      )}
    >
      {items.map((item, index) => {
        const Icon = item.icon;
        const isFirst = index === 0;
        const isLast = index === items.length - 1;
        
        return (
          <Link
            key={item.to}
            to={item.to}
            className={cn(
              "inline-flex items-center justify-center gap-2 px-6 py-3 font-heading font-bold uppercase tracking-wider transition-all",
              "bg-primary text-dark",
              // Borders between items
              !isFirst && "border-t-[3px] sm:border-t-0 sm:border-l-[3px] border-dark",
              // Hover effect - sfondo bianco
              "hover:bg-white hover:text-dark active:bg-gray-100 active:text-dark"
            )}
          >
            {Icon && <Icon className="w-5 h-5" />}
            <span>{item.label}</span>
          </Link>
        );
      })}
    </div>
  );
};
